// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.block-info-header-skeleton {\n  display: grid;\n  justify-items: center;\n  background-color: white;\n  padding: 10px 0px;\n}\n.block-info-header-skeleton .titel {\n  height: 25px !important;\n}\n.block-info-header-skeleton .MuiSkeleton-text {\n  margin: 7px ​ !important;\n}\n.block-info-header-skeleton .info-bank-block {\n  margin: 5px;\n}", ""]);
// Exports
module.exports = exports;
